















import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
  name: "LfsCheckBox",
  components: {},
})
export default class LfsSelectBox extends Vue {

  @Prop({
    type: String,
  })
  header!: String;
  @Prop({
    type: [Object, Boolean],
  })
  value!: [Object, Boolean];
  @Prop({
    type: String,
  })
  label!: String;

  protected check:any = this.value

  @Watch('value')
  changeValue(newValue:any){
    this.check = newValue
  }

}
